module.exports = __webpack_public_path__ + "img/sy_16.dcaf03f0.png";